<template>
  <van-tabbar
    v-if="show"
    v-model="active"
    active-color="#e0739b"
    :border="true"
    inactive-color="#a99cba"
  >
  <!-- 首页 -->
    <van-tabbar-item to="/Home">
      <span>{{ $t("tabbar.index") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/icon1_select.png' : '/img/footer/icon1.png'"
          :alt="$t('tabbar.index')"
        />
      </template>
    </van-tabbar-item>
    <!-- 视频 -->
    <van-tabbar-item to="/Video">
      <span>{{ $t("tabbar.video") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/icon2_select.png' : '/img/footer/icon2.png'"
          :alt="$t('tabbar.video')"
        />
      </template>
    </van-tabbar-item>
    <!-- 中间 -->
    <van-tabbar-item to="/Goods">
      <span>{{ $t("tabbar.goods") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/icon3_select.png' : '/img/footer/icon3.png'"
        />
      </template>
    </van-tabbar-item>
    <!-- 视频 -->
    <van-tabbar-item to="/Message">
      <span>{{ $t("tabbar.message") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/icon4_select.png' : '/img/footer/icon4.png'"
          :alt="$t('tabbar.message')"
        />
      </template>
    </van-tabbar-item>
    <!-- <van-tabbar-item to="/Message">
      <span>{{ $t("tabbar.game_record") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/icon4_select.png' : '/img/footer/icon4.png'"
          :alt="$t('tabbar.game_record')"
        />
      </template>
    </van-tabbar-item> -->
    <!-- 我的 -->
    <van-tabbar-item to="/Mine">
      <span>{{ $t("tabbar.user") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/icon5_select.png' : '/img/footer/icon5.png'"
          :alt="$t('tabbar.user')"
        />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      active: 0
    };
  },
  methods: {},
  watch: {
    $route(to) {
      console.log(to)
      if (to.name == "home") {
        this.active = 0;
        this.show = true;
      } else if (to.name == "video") {
        this.active = 1;
        this.show = true;
      } else if (to.name == "Goods") {
        this.active = 2;
        this.show = true;
      } else if (to.name == "Message") {
        this.active = 3;
        this.show = true;
      } else if (to.name == "mine") {
        this.active = 4;
        this.show = true;
      } else {
        this.show = false;
      }
    },
  },
  created() {
    if (this.$route.name == "home") {
      this.active = 0;
      this.show = true;
    } else if (this.$route.name == "video") {
      this.active = 1;
      this.show = true;
    } else if (this.$route.name == "Goods") {
      this.active = 2;
      this.show = true;
    } else if (this.$route.name == "Message") {
      this.active = 3;
      this.show = true;
    } else if (this.$route.name == "mine") {
      this.active = 4;
      this.show = true;
    } else {
      this.show = false;
    }
  },
};
</script>

<style lang="less" scoped>
@tabbar-height: 3.13rem;
@tabbar-img: 1.38rem;
.van-tabbar {
  width: 31.25rem;
  min-height: @tabbar-height;
  height: auto;
  z-index: 100;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border-top: 1px solid rgba(255, 255, 255, 0.9);
  box-shadow: 0 -0.3rem 1.2rem rgba(183, 156, 236, 0.16);
  left: calc(50vw - 15.625rem);
}
.van-tabbar-item__icon img {
  height: @tabbar-img;
}
.van-tabbar-item {
  font-size: 0.75rem;
  background: transparent;
}

/deep/ .van-tabbar-item__text {
  width: 100%;
  padding: 0 2px;
  text-align: center;
  line-height: 1.15;
  word-break: break-word;
}

[class*="van-hairline"]::after {
  border: none !important;
}


@media (max-width: 31.25rem) {
  .van-tabbar {
    width: 100%;
    left: calc(50vw - 50%);
  }
}
</style>
